import React from 'react';

/**
 * Google "G" glyph. Keeps the authentic four-segment Google geometry (the
 * open ring + inward bar + white counter) but paints the segments in a
 * graduated GRAYSCALE ramp (#3C4043 → #BDC1C6) instead of brand colors.
 *
 * AI-NOTE: Fixed grayscale, NOT `currentColor`. A flat single-tone fill
 * erased the four-arc structure that makes the mark read as *Google* (it
 * looked like a generic bold G); the gray ramp restores that read while
 * staying within the black-and-white surface-mark direction. Because it is
 * a brand lockup it holds its tones in both the positive and negative chip
 * states (it does NOT dim to slate-400 with the row, unlike the plain
 * map/spark/knot glyphs). This is the one deliberate exception to the
 * "every glyph tracks currentColor" rule – keep the four grays distinct so
 * the segmentation survives at 14px. Do not reintroduce brand color.
 */
export function GoogleGlyph({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      viewBox="0 0 48 48"
      role="img"
      aria-hidden="true"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Google</title>
      <path fill="#BDC1C6" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917" />
      <path fill="#3C4043" d="m6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691" />
      <path fill="#80868B" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44" />
      <path fill="#5F6368" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917" />
    </svg>
  );
}
